import {RemotePatchUpdateEmail} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {ProfileChangeDataEndpoints} from 'main/factories/usecases/endpoints';
import {PatchUpdateEmail} from 'domain/usecases';

export const makePatchUpdateEmail = (): PatchUpdateEmail =>
	new RemotePatchUpdateEmail(
		makeBFFApiUrl(ProfileChangeDataEndpoints.checkEmail),
		makeAuthorizeHttpClientDecorator(),
	);
